'use client';

import React, { useState } from 'react';

import { useAppDispatch, useAppSelector } from '@/redux-store/hooks';
import { setLanguage } from '@/redux-store/slices/translation';
import { TranslationEnum } from '@/types/enums/translation.enum';
import FlagIcon from './FlagIcon';
import TranslationButton from './TranslationButton';

import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import Typography from '@mui/material/Typography';
import type { Flag } from './FlagIcon';

interface LanguageOption {
    label: string;
    value: TranslationEnum;
    code: Flag;
}

const languages: LanguageOption[] = [
    { label: 'Tiếng Việt', value: TranslationEnum.VI, code: 'vn' as const },
    { label: 'English', value: TranslationEnum.EN, code: 'us' as const },
];

export default function TranslationDropdown() {
    const dispatch = useAppDispatch();
    const currentLang = useAppSelector(s => s.translation.lang);

    const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null);
    const [tooltipOpen, setTooltipOpen] = useState(false);

    const open = Boolean(anchorEl);

    const handleToggle = (e: React.MouseEvent<HTMLElement>) => {
        setAnchorEl(open ? null : e.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    const handleSelect = (value: TranslationEnum) => {
        dispatch(setLanguage(value));
        handleClose();
    };

    return (
        <>
            <TranslationButton
                open={open}
                tooltipOpen={tooltipOpen}
                setTooltipOpen={setTooltipOpen}
                onToggle={handleToggle}
            />
            <Menu
                anchorEl={anchorEl}
                open={open}
                onClose={handleClose}
                anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
                transformOrigin={{ vertical: 'top', horizontal: 'right' }}
                PaperProps={{
                    sx: {
                        minWidth: 140,
                    },
                }}
            >
                {languages.map(lang => (
                    <MenuItem
                        key={lang.value}
                        selected={lang.value === currentLang}
                        onClick={() => handleSelect(lang.value)}
                        sx={{
                            display: 'flex',
                            alignItems: 'center',
                            gap: 1.5,
                            p: 2,
                            transition: 'background 150ms',
                            overflow: 'visible',
                            '& .MuiSvgIcon-root': {
                                zIndex: 1,
                            },
                            '&.Mui-selected': {
                                backgroundColor: 'action.selected',
                                '&:hover': {
                                    backgroundColor: 'action.selected',
                                },
                            },
                            '&:hover': {
                                backgroundColor: 'action.hover',
                            },
                        }}
                    >
                        {/* <Box
                            component={AppIcon}
                            name={lang.icon}
                            sx={{
                                width: 32,
                                height: 24,
                                flexShrink: 0,
                                overflow: 'visible',
                            }}
                        /> */}
                        <FlagIcon
                            code={lang.code}
                            style={{ marginRight: 12 }}
                        />
                        <Typography variant='body2' sx={{ flexGrow: 1 }}>
                            {lang.label}
                        </Typography>
                    </MenuItem>
                ))}
            </Menu>
        </>
    );
}
